import { render, staticRenderFns } from "./AlertInfo.vue?vue&type=template&id=e94c8042&scoped=true&"
import script from "./AlertInfo.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AlertInfo.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AlertInfo.vue?vue&type=style&index=0&id=e94c8042&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94c8042",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e94c8042')) {
      api.createRecord('e94c8042', component.options)
    } else {
      api.reload('e94c8042', component.options)
    }
    module.hot.accept("./AlertInfo.vue?vue&type=template&id=e94c8042&scoped=true&", function () {
      api.rerender('e94c8042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/core/AlertInfo/AlertInfo.vue"
export default component.exports